import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    FormBuilder,
    FormGroup,
    Validators,
    ValidatorFn,
} from '@angular/forms';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';
import { UserAccess } from '@models/user-access.model';
import { DropdownOptionInterface } from '@models/dropdown.interface';
import { PermissionService } from '@services/permissions.service';

import { environment } from '@environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    public loginForm: FormGroup;
    public submitted: boolean = false;
    public redirect: string = undefined;
    public loginError: boolean = false;
    public passwordValidator: ValidatorFn[] = [Validators.minLength(7)];
    public userAccess: UserAccess[];
    public parsedUserAccess: DropdownOptionInterface[];
    public environment = environment.urlBackOffice;

    private allowedRoleNames: string[] = ['Entrepreneur'];

    constructor(
        private formBuilder: FormBuilder,
        private credentialsApiService: CredentialsApiService,
        private router: Router,
        private active_route: ActivatedRoute,
        private permissionService: PermissionService
    ) {
        if (
            this.credentialsApiService.currentUserValue &&
            localStorage.getItem('user-access')
        ) {
            this.router.navigate(['/my-page']);
        }
    }

    ngOnInit() {
        this.getQueryParams();
        this.loginForm = this.formBuilder.group({});
    }

    getQueryParams() {
        this.active_route.queryParams.subscribe((params) => {
            this.redirect = params['redirect'];
        });
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    onSubmit() {
        this.submitted = true;
        if (!this.loginForm.invalid) {
            this.login(
                this.loginForm.value.username,
                this.loginForm.value.password
            );
        }
    }

    setUserAccess(id: string): void {
        localStorage.setItem('user-access', id.toString());
        const permissions = this.userAccess.find(
            (userAccess) => userAccess.id === id
        ).role.permissions;
        this.permissionService.setPermissions(permissions);
        this.getUser();
    }

    login(username: string, password: string) {
        this.loginError = false;

        this.credentialsApiService.login(username, password).subscribe(
            (response) => {
                this.credentialsApiService.getUserAccess().subscribe(
                    (response) => {
                        // map response into UserAcces model
                        this.userAccess = response.map((res: Object) => {
                            if (
                                this.allowedRoleNames.includes(res['role_name'])
                            ) {
                                return new UserAccess(
                                    res['id'],
                                    res['company_name'],
                                    res['role_name'],
                                    res['role']
                                );
                            }
                        });

                        // remove undefined/null items
                        this.userAccess = this.userAccess.filter((item) => {
                            return item != null || item != undefined;
                        });

                        // if has only one access, go ahead
                        if (this.userAccess.length == 1) {
                            this.setUserAccess(this.userAccess[0].id);
                        } else {
                            // otherwhise make a select
                            this.parsedUserAccess = this.userAccess.map(
                                (access: UserAccess) => {
                                    return {
                                        key: access.id,
                                        value: `${access.companyName} - ${access.roleName}`,
                                    };
                                }
                            );
                        }

                        this.submitted = false;
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            },
            (error) => {
                this.loginError = true;
                console.error(error);
            }
        );
    }

    getUser() {
        this.credentialsApiService.getUser().subscribe(
            () => {
                if (this.redirect != undefined) {
                    window.location.href = this.redirect;
                } else {
                    this.router.navigate(['/my-page']);
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }
}
